import { render, staticRenderFns } from "./DirectCostsOverTimeChart.vue?vue&type=template&id=51f07fc9&scoped=true"
import script from "./DirectCostsOverTimeChart.vue?vue&type=script&lang=js"
export * from "./DirectCostsOverTimeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f07fc9",
  null
  
)

export default component.exports